export enum EnumMaster {
  /** 記帳代號 */
  chkCode1 = 'chkCode1',
  /** 業者名稱 */
  expressCnName = 'expressCnName',
  /** 快遞倉站 */
  warehouse = 'warehouse',
  /** 主號 */
  mawbNo = 'mawbNo',
  /** 開始日期 */
  startDate = 'startDate',
  /** 結束日期 */
  endDate = 'endDate',
  /** 開始時間 */
  startTime = 'startTime',
  /** 結束時間 */
  endTime = 'endTime',
  endDateValid = 'endDateValid',
  endTimeValid = 'endTimeValid',
  startDateValid = 'startDateValid',
  startTimeValid = 'startTimeValid',
}
export default EnumMaster;
